module.exports = __webpack_public_path__ + "img/SMP.a5727f21.png";